var isNil = function isNil(value) {
  return value === null || value === undefined;
};

export default isNil;